/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContentEditorShowResponseMetaContentOwningCompanySpace } from './ContentEditorShowResponseMetaContentOwningCompanySpace';
import {
    ContentEditorShowResponseMetaContentOwningCompanySpaceFromJSON,
    ContentEditorShowResponseMetaContentOwningCompanySpaceFromJSONTyped,
    ContentEditorShowResponseMetaContentOwningCompanySpaceToJSON,
} from './ContentEditorShowResponseMetaContentOwningCompanySpace';

/**
 * Content viewer content info
 * @export
 * @interface ContentViewerContentInfo
 */
export interface ContentViewerContentInfo {
    /**
     * 
     * @type {number}
     * @memberof ContentViewerContentInfo
     */
    content_id: number;
    /**
     * 
     * @type {ContentEditorShowResponseMetaContentOwningCompanySpace}
     * @memberof ContentViewerContentInfo
     */
    owning_company_space: ContentEditorShowResponseMetaContentOwningCompanySpace;
}

/**
 * Check if a given object implements the ContentViewerContentInfo interface.
 */
export function instanceOfContentViewerContentInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "content_id" in value;
    isInstance = isInstance && "owning_company_space" in value;

    return isInstance;
}

export function ContentViewerContentInfoFromJSON(json: any): ContentViewerContentInfo {
    return ContentViewerContentInfoFromJSONTyped(json, false);
}

export function ContentViewerContentInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContentViewerContentInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content_id': json['content_id'],
        'owning_company_space': ContentEditorShowResponseMetaContentOwningCompanySpaceFromJSON(json['owning_company_space']),
    };
}

export function ContentViewerContentInfoToJSON(value?: ContentViewerContentInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content_id': value.content_id,
        'owning_company_space': ContentEditorShowResponseMetaContentOwningCompanySpaceToJSON(value.owning_company_space),
    };
}

